import { render, staticRenderFns } from "./unit-detail.vue?vue&type=template&id=e21f7014"
import script from "./unit-detail.vue?vue&type=script&lang=js"
export * from "./unit-detail.vue?vue&type=script&lang=js"
import style0 from "./unit-detail.vue?vue&type=style&index=0&id=e21f7014&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e21f7014')) {
      api.createRecord('e21f7014', component.options)
    } else {
      api.reload('e21f7014', component.options)
    }
    module.hot.accept("./unit-detail.vue?vue&type=template&id=e21f7014", function () {
      api.rerender('e21f7014', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/units/detail/unit-detail.vue"
export default component.exports